<template>
  <div>
    <v-data-table
      v-bind="this.$attrs"
      item-key="id"
      loading-text="Đang Tải"
      no-data-text="Không có dữ liệu"
      :options.sync="tableOptions"
      :server-items-length="studentCount"
      :headers="headers"
      :items="mealReports"
      :loading="loading"
      :footer-props="footerOptions"
    >
      <template #item.dob="{ item }">
        {{ item.student.dob | ddmmyyyy }}
      </template>
      <template #item.class="{ item }">
        <router-link style="text-decoration: none" :to="'/class/' + $_get(item, 'student.currentClass.id')">
          <span>{{ $_get(item, 'student.currentClass.title') }}</span>
        </router-link>
      </template>
      <template #item.student="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <template #item.selectedMenu="{ item }">
        <div>{{ $_get(item, 'studentMenu.selectedMenu') | selectedMenu }}</div>
      </template>
      <template #item.mealTransferStatus="{ item }">
        <div>{{ $_get(item, 'mealTransferStatus') | mealTransferStatus }}</div>
      </template>
      <template #item.actions="{ item }">
        <v-hover v-slot="{ hover }">
          <v-icon :color="hover ? 'primary' : ''" @click="showMealDetailReportDialog(item)">mdi-eye</v-icon>
        </v-hover>
      </template>
    </v-data-table>
    <MealReportDetailDialog ref="meal-detail-report-dialog" />
  </div>
</template>
<script>
import { get } from 'lodash'
import { mapActions, mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import MealReportDetailDialog from './MealReportDetailDialog.vue'

const originHeaders = [
  {
    text: 'Học sinh',
    value: 'student',
    align: 'left',
    sortable: false
  },
  {
    text: 'Lớp',
    value: 'class',
    align: 'left',
    sortable: false
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
    align: 'left',
    sortable: false
  },
  {
    text: 'Thực đơn 1',
    value: 'menu1Count',
    align: 'left',
    sortable: false
  },
  {
    text: 'Thực đơn 2',
    value: 'menu2Count',
    align: 'left',
    sortable: false
  },
  {
    text: 'Tổng suất đã đăng ký',
    value: 'totalCount',
    align: 'left',
    sortable: false
  },
  {
    text: 'Tổng suất ăn thực tế',
    value: 'mealAteLength',
    align: 'left',
    sortable: false
  },
  {
    text: 'Tổng suất hủy hợp lệ',
    value: 'validCancelLength',
    align: 'left',
    sortable: false
  },
  {
    text: 'Tổng suất ăn tính tiền',
    value: 'totalAmountGetMoney',
    align: 'left',
    sortable: false
  },
  {
    text: 'Thao tác',
    value: 'actions',
    align: 'left',
    sortable: false
  }
]

export default {
  components: {
    CardStudentName,
    MealReportDetailDialog
  },
  props: {},
  data() {
    return {
      headers: originHeaders,
      tableOptions: {},
      reportDate: null // Dữ liệu ngày lấy report, tháng của report sẽ phụ thuộc vào tháng và năm trong biến date này
    }
  },
  async created() {
    this.refresh({})
  },
  methods: {
    ...mapActions('MealReport', ['requestPageSettings', 'searchStudentMealReports', 'getStudentMealReportByMonth']),
    /**
     * Hàm chạy khi filter data thay đổi
     */
    async refresh(query) {
      query = query || {}
      this.reportDate = get(query, 'date', '')
      await this.searchStudentMealReports(query)
    },
    showMealDetailReportDialog(item) {
      const { student } = item
      this.$refs['meal-detail-report-dialog'].openDialog(student, this.reportDate)
    }
  },
  computed: {
    ...mapState('MealReport', ['studentCount', 'mealReports', 'loading']),
    footerOptions() {
      let footer = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
    pageText() {
      const page = this.tableOptions.page
      const itemsPerPage = this.tableOptions.itemsPerPage
      const pageStart = (page - 1) * itemsPerPage + 1
      let pageStop = page * itemsPerPage
      pageStop = pageStop > this.studentCount || pageStop === -1 ? this.studentCount : pageStop
      return `${pageStart}-${pageStop} trên ${this.studentCount}`
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
